import React from 'react';  // eslint-disable-line
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    Grid,
    Typography,
    withStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { connect, MapStateToProps } from 'react-redux';
import { Section } from '../../../../../controls/section';
import { State } from '../../../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import {
    getDeathClaimContactDetails,
    Claimant,
} from '../../contact-details/contact-details-reducer';
import { LabeledValue } from '../../../../../controls/labeled-value';

interface OwnProps {}

interface StateProps {
    readonly claimants: Claimant[];
    isReadOnly: boolean;
}

type Props = OwnProps & StateProps & StyledComponent;

const fifthItemStyle: React.CSSProperties = {
    flexBasis: '20%',
    maxWidth: '20%',
};

const communicationsDetailsView: React.FunctionComponent<Props> = ({
    classes,
    claimants,
}: Props) => {
    const claimantWithCommunicationDetails = claimants?.find(
        claimant => claimant.claimantDetails?.communicationDetails
    );

    const contactPersons =
        claimantWithCommunicationDetails?.claimantDetails?.communicationDetails?.contactPersons ??
        [];

    if (contactPersons.length === 0) {
        return (
            <Grid item xs={12}>
                <Grid container justify="flex-start">
                    <Grid item xs={3} lg={2}>
                        <LabeledValue
                            label="Is there an additional person you would like to add?"
                            value={'No'}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return (
        <Section title={``}>
            <Grid item xs={12}>
                <Grid container justify="flex-start">
                    <Grid item xs={12}>
                        <LabeledValue
                            label="Is there an additional person you would like to add?"
                            value={'Yes'}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={0}>
                {contactPersons.map((person, personIndex) => (
                    <React.Fragment key={`contact-${personIndex}`}>
                        {personIndex > 0 && (
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Accordion
                                defaultExpanded={personIndex === 0}
                                className={classes?.accordion}
                                style={{
                                    marginBottom: personIndex < contactPersons.length - 1 ? 16 : 0,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`comm-${personIndex}-content`}
                                    id={`comm-${personIndex}-header`}
                                >
                                    <Typography variant="subtitle2">
                                        Contact person {personIndex + 1}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <Grid container spacing={0} justify="flex-start">
                                        <Grid item style={fifthItemStyle}>
                                            <LabeledValue
                                                label="Contact Person First Name"
                                                value={person.firstName}
                                            />
                                        </Grid>
                                        <Grid item style={fifthItemStyle}>
                                            <LabeledValue
                                                label="Contact Person Surname"
                                                value={person.surname}
                                            />
                                        </Grid>
                                        <Grid item style={fifthItemStyle}>
                                            <LabeledValue
                                                label="Work phone number"
                                                value={person.workTelephoneNumber}
                                            />
                                        </Grid>
                                        <Grid item style={fifthItemStyle}>
                                            <LabeledValue
                                                label="Cell number"
                                                value={person.cellphoneNumber}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <LabeledValue
                                                label="Email Address"
                                                value={person.emailAddress}
                                            />
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>
        </Section>
    );
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    claimants: getDeathClaimContactDetails(state).claimants,
    isReadOnly: state.claimSession.readOnly,
});

const mapDispatchToProps = {};

export const CommunicationsDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(communicationsDetailsView));
